import { render, staticRenderFns } from "./PendingConsentShow.vue?vue&type=template&id=48150138&"
import script from "./PendingConsentShow.vue?vue&type=script&lang=js&"
export * from "./PendingConsentShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports